<template>
  <div class="d-flex align-items-center">
    <div>
      <avatar
        inline
        color="#fff"
        :size="30"
        :username="person.name"
        :initials="getInitial(person.name)"
      ></avatar>
    </div>
    <div class="align-self-center">
      <h6 class="d-inline mb-0" style="margin-left: 10px;">
        {{ person.name }}
      </h6>
      <small class="text-muted" v-if="person.person_code">
        #{{ person.person_code }}</small
      >

      <template v-if="showExpanded">
        <br />
        <small class="text-muted" style="margin-left: 10px;" v-if="hasBought">
          Ticket Médio: {{ avg_net_total | decimal }} ({{
            count_net_total
          }}
          vendas)</small
        >
        <small class="text-muted" style="margin-left: 10px;" v-else>
          Nunca comprou
        </small>
      </template>
      <i
        v-if="!person.can_buy_in_payment_method_5"
        class="fas fa-lg fa-exclamation-circle text-danger ml-2"
        title="Bloqueado para compras no crediário"
      ></i>
    </div>
  </div>
</template>

<script>
  import Avatar from "vue-avatar";

  export default {
    props: {
      person: {},
      expanded: {
        default: false
      }
    },

    components: { Avatar },

    computed: {
      avg_net_total() {
        try {
          return this.person.stats.filter(row => row.type == "avg_net_total")[0]
            .value;
        } catch (error) {
          return 0;
        }
      },

      count_net_total() {
        try {
          return Math.round(
            this.person.stats.filter(row => row.type == "count_net_total")[0]
              .value
          );
        } catch (error) {
          return 0;
        }
      },

      hasBought() {
        return this.count_net_total > 0;
      },

      showExpanded() {
        return this.expanded && this.person.is_client == 1;
      }
    },

    methods: {
      getInitial(value) {
        return value.slice(0, 1);
      },

      getWhatsAppLink(people) {
        let name = people.name.replace(/ .*/, "");
        let link = "https://api.whatsapp.com/send?phone=+55" + people.phone_wa;
        let msg = "&text=Olá " + name + ",Tudo Bem?";

        return link + msg;
      }
    }
  };
</script>

<style>
</style>